import { v4 as uuidV4 } from 'uuid';
import SearchTracking, { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import { getBulkSearchTransientFacilities, getBulkSearchTransientFacilitiesLoadMoreSpots, } from 'api/search-v2/power-booking/facilities/getBulkSearchTransientFacilities';
import { getSearchLimits } from 'utils/search-limits';
import { notify } from '../notification/notification-actions';
import trackErrorMessageDisplayed from 'segment/events/error-message-displayed';
import { getWebExperimentCookie } from 'utils/web-experiment';
import { getLoyaltyProgramFilterParams } from 'store/filters/loyalty-filter-utils';
export const SPOTS_GET_BULK_TRANSIENT_V2 = 'SPOTS_GET_BULK_TRANSIENT_V2';
function handleError(dispatch, error) {
    trackErrorMessageDisplayed({
        message: 'Error fetching spots',
        screen: 'search',
        action: 'fetching spots',
    });
    dispatch(notify({
        id: uuidV4(),
        type: 'error',
        message: 'Error fetching spots',
    }));
    return {
        error: error?.data,
    };
}
export const loadBulkSearchSpotsTransientV2 = (args) => {
    const { searchTrackingAction, locationContext = undefined, mapCenter = undefined, mapBounds = undefined, eventId = undefined, searchLimit = undefined, } = args;
    return (dispatch, getState) => {
        const prevState = getState();
        const searchRequestState = prevState.searchRequest;
        const { latitude, longitude, powerBookingPeriods, operator_id: operatorId, rebook_reservation_id: rebookId, filterSpot, powerBookingSource, } = searchRequestState;
        const loyaltyProgramSelected = prevState.filters.loyaltyProgram;
        const userState = prevState.user;
        const { data: { isAdmin, operatorLoyaltyProgram }, } = userState;
        const timezone = prevState.city.data.timezone;
        const fingerprint = getWebExperimentCookie();
        SearchTracking.updateAction(searchTrackingAction);
        const { sessionUUID, searchUUID, actionUUID, action, } = SearchTracking.getValues();
        const { resultLimit, maxDistance } = getSearchLimits({
            locationContext: locationContext === undefined ? '' : locationContext,
            mapCenter,
            mapBounds,
            isSearchDurationMoreThan24Hours: false,
            searchLimit,
        });
        const loyaltyProgramFilterParams = getLoyaltyProgramFilterParams({
            operatorLoyaltyProgram,
            loyaltyProgramSelected,
        });
        /* eslint-disable camelcase */
        const params = {
            session_id: sessionUUID,
            search_id: searchUUID,
            action_id: actionUUID,
            fingerprint,
            action,
            ...loyaltyProgramFilterParams,
            ...(mapCenter
                ? {
                    origin_lat: latitude,
                    origin_lon: longitude,
                    lat: mapCenter.latitude,
                    lon: mapCenter.longitude,
                }
                : {
                    lat: latitude,
                    lon: longitude,
                }),
        };
        const requestData = {
            periods: powerBookingPeriods,
            oversize: false,
            show_unavailable: isAdmin,
            sort_by: 'relevance',
            include_walking_distance: true,
            max_distance_meters: maxDistance,
            page_size: resultLimit,
            operator_id: operatorId,
            /* eslint-enable camelcase */
        };
        const formatOptions = {
            eventId,
            timezone,
            rebookId,
            filterSpot,
            powerBookingSource: powerBookingSource,
        };
        return dispatch({
            type: SPOTS_GET_BULK_TRANSIENT_V2,
            payload: getBulkSearchTransientFacilities(requestData, params, formatOptions).then(response => ({
                ...response,
                mapBounds,
            })),
            meta: {
                originalArgs: args,
            },
        }).catch((error) => handleError(dispatch, error));
    };
};
export const loadMoreBulkSearchSpotsTransientV2 = ({ locationContext, }) => {
    return (dispatch, getState) => {
        const prevState = getState();
        const loadMoreSpotsUrl = prevState.spots.loadMoreSpotsUrl;
        const searchRequestState = prevState.searchRequest;
        // empty loadMoreSpotsUrl (@next) indicates no more spots are available from api
        if (!loadMoreSpotsUrl) {
            return;
        }
        const { powerBookingPeriods, operator_id: operatorId, powerBookingSource, } = searchRequestState;
        const userState = prevState.user;
        const { data: { isAdmin }, } = userState;
        const { resultLimit, maxDistance } = getSearchLimits({
            locationContext: locationContext === undefined ? '' : locationContext,
            isSearchDurationMoreThan24Hours: false,
        });
        /* eslint-disable camelcase */
        const requestData = {
            periods: powerBookingPeriods,
            oversize: false,
            show_unavailable: isAdmin,
            sort_by: 'relevance',
            include_walking_distance: true,
            page_size: resultLimit,
            operator_id: operatorId,
            max_distance_meters: maxDistance,
        };
        /* eslint-enable camelcase */
        SearchTracking.updateAction(SEARCH_TRACKING_ACTIONS.LIST_SEARCH_NEXT);
        const formatOptions = {
            powerBookingSource: powerBookingSource,
        };
        return dispatch({
            type: SPOTS_GET_BULK_TRANSIENT_V2,
            payload: getBulkSearchTransientFacilitiesLoadMoreSpots({
                // Below includes walking distance until BE includes it in @next
                loadMoreSpotsUrl: `${loadMoreSpotsUrl}&include_walking_distance=true`,
            }, requestData, formatOptions)
                .then(response => ({
                loadMoreSpotsUrl: response.loadMoreSpotsUrl,
                results: [...prevState.spots.data, ...response.results], // append to existing spots
            }))
                .catch(error => handleError(dispatch, error)),
        });
    };
};
